import { MaxValues, MergeFieldsReturnData } from '@dev/ee-api/ee-api-models';
import { Action } from 'redux';

export type MergeFieldsMaxFieldsValuesMap = Record<string, MaxValues>;

export enum MergeFieldsStateStatus {
    DEFAULT = 'default',
    LOADING = 'loading',
    LOADED = 'loaded',
    LOAD_ERROR = "load-error",
}

export interface MergeFieldsLoadStartAction extends Action {
    type: MergeFieldsActionTypes.LOAD_START,
}

export interface MergeFieldsLoadSuccessAction extends Action {
    type: MergeFieldsActionTypes.LOAD_SUCCESS,
    payload: {
        data: MergeFieldsReturnData,
    }
}

export interface MergeFieldsLoadErrorAction extends Action {
    type: MergeFieldsActionTypes.LOAD_ERROR,
}

export interface MergeFieldsState {
    status: MergeFieldsStateStatus,
    data?: MergeFieldsReturnData,
    maxFieldsValuesMap?: MergeFieldsMaxFieldsValuesMap,
}

export enum MergeFieldsActionTypes {
    LOAD_START = '@@mergeFields/LOAD_START',
    LOAD_SUCCESS = '@@mergeFields/LOAD_SUCCESS',
    LOAD_ERROR = '@@mergeFields/LOAD_ERROR',
}
